import FalconCardHeader from 'components/common/FalconCardHeader';
import { jwtDecode } from 'jwt-decode';
import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DynamicReport from 'screens/common/DynamicReport';
import reportprobs from 'screens/common/DynamicReport/reportprobs';
import FarmLevelReportTable from 'screens/WeatherDashboard/ManageProjectsTable';
import { getTenantFromToken } from 'utils/routeUtils';
import useApi from 'hooks/useApi';
import { getWeatherReportdata } from 'api/endpoints/Weather';
import { get } from 'lodash';

const WeatherCards = () => {
  const tenant = getTenantFromToken();
  const [exportdata, setExportData] = useState({});
  const [weatherData, setWeatherData] = useState({});
  const getWeatherReportDataApi = useApi(getWeatherReportdata);

  useEffect(() => {
    let limit = 3;
    let cursor = 0;
    let district_ids = [];
    const state_ids = [];
    getWeatherReportDataApi.request({
      cursor,
      limit: limit,
      filter: '',
      district_ids,
      state_ids
    });
  }, []);

  useEffect(() => {
    const tabledata = get(getWeatherReportDataApi, 'data.results', []);
    setWeatherData(tabledata);
  }, [getWeatherReportDataApi.data]);

  return (
    <Row className="g-3 flex-grow-1" style={{ maxHeight: '400px' }}>
      {weatherData?.data && Object.keys(weatherData?.data).length > 0 && (
        <>
          <Col md={6} className="mb-4" style={{ height: '350px' }}>
            <Card className="d-flex h-100">
              <FalconCardHeader
                title={'7 Days Weather Forecast'}
                titleTag="h5"
                light={true}
                endEl={
                  <>
                    <Link
                      to={`/${tenant}/weatherReport`}
                      style={{ fontSize: '14px' }}
                    >
                      See More
                    </Link>
                  </>
                }
              />
              <CardBody style={{ paddingTop: '44px', overflowY: 'auto' }}>
                <FarmLevelReportTable
                  weatherData={weatherData}
                  key={'SOIL_WATER_RETENTION_CAPACITY'}
                  hyperlink={false}
                  showFilter={false}
                  selectedDistrict={[]}
                  setExportData={setExportData}
                  limit={3}
                  showHeader={false}
                  showFooter={false}
                  showFilters={false}
                />
              </CardBody>
            </Card>
          </Col>
          <Col md={6} className="mb-4" style={{ height: '350px' }}>
            <Card className="d-flex h-100">
              <FalconCardHeader
                title={'Weather Alert'}
                titleTag="h5"
                light={true}
                endEl={
                  <>
                    <Link
                      to={`/${tenant}/perilAlerts`}
                      style={{ fontSize: '14px' }}
                    >
                      See More
                    </Link>
                  </>
                }
              />
              <CardBody style={{ overflowY: 'hidden' }}>
                <DynamicReport
                  {...reportprobs('perilAlertsDashboard')}
                  district_ids={[7, 6, 8, 9]}
                />
              </CardBody>
            </Card>
          </Col>
        </>
      )}
    </Row>
  );
};

export default WeatherCards;
